export enum AllocationCostMethod {
  Percentage = 'Percentage',
  Fixed = 'Fixed',
  Prorated = 'Prorated',
}
